import { render, staticRenderFns } from "./LogDetalhes.vue?vue&type=template&id=36287ab8"
import script from "./LogDetalhes.vue?vue&type=script&lang=js"
export * from "./LogDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports